import React from "react";
import cn from "classnames";
import { UpdatePageModel } from "../UpdatePageModel";
import { IStage } from "interfaces";
import { ConfirmIcon } from "components";

interface IConfirmCardProps {
    model: UpdatePageModel,
    stage: IStage,
    stageIndex: number,
    onConfirm: () => void,
}

export function ConfirmCard({ model, stage, stageIndex, onConfirm }: IConfirmCardProps) {
    const canConfirm = model.canConfirmStage(model.update, stage, stageIndex);

    return (<div className={cn('update_confirm', {
        'update_confirm_readyToConfirm': canConfirm,
    })}>
        <div className="update_confirm_box" onClick={onConfirm}>
            <ConfirmIcon isConfirmed={stage.isConfirmed} />
        </div>
        <div className="update_confirm_tri" onClick={onConfirm}>

        </div>
        <div className="update_confirm_line"></div>
    </div>);
}